import type { AxiosRequestConfig } from 'axios';

export type IRequesterErrorConfig = Pick<
  AxiosRequestConfig,
  'url' | 'method' | 'headers' | 'params' | 'data' | 'timeout'
>;

export enum EN_REQUEST_ERRORS {
  AXIOS = 'AXIOS',
  CLIENT = 'CLIENT',
  JSON_SCHEMA = 'JSON_SCHEMA',
  UNKNOWN = 'UNKNOWN',
}

export interface IRequesterResponse<P> {
  success: true;
  statusCode: number;
  data: P;
  headers?: { [key: string]: string };
  config?: IRequesterErrorConfig;
  duration?: number | null;
}
export interface IRequesterError<T = any> {
  success: false;
  statusCode: number;
  errorType: EN_REQUEST_ERRORS;
  config?: IRequesterErrorConfig;
  data?: T;
  duration?: number | null;
}

export type TRequesterResponse<P> = IRequesterError | IRequesterResponse<P>;
